// extracted by mini-css-extract-plugin
export default {"rounded":"style_rounded__mgPkw"};